import React from "react";
import { FeeRunParticipantContainer } from "../../../containers";

const FeeRunParticipantDetails = (props) => {
  return <FeeRunParticipantContainer {...props} />;
};

export default FeeRunParticipantDetails;
